export interface SideNavState {
  opened: boolean;
}

export const initialState: SideNavState = {
  opened: false
};
